import type { ShoppingCartContextProps } from 'src/app/shared/hooks/useShoppingCart';

export const isShoppingCartLoading = ({
  cartProductInProgress,
  isCartAndPayAndPostPageV2FeatureEnabled,
  isTestShoppingCartFeatureEnabled,
}: {
  cartProductInProgress?: ShoppingCartContextProps['cartProductInProgress'];
  isCartAndPayAndPostPageV2FeatureEnabled: boolean;
  isTestShoppingCartFeatureEnabled: boolean;
}) => {
  const isFeatureOn =
    isCartAndPayAndPostPageV2FeatureEnabled || isTestShoppingCartFeatureEnabled;

  if (!isFeatureOn) {
    return false;
  }

  if (!cartProductInProgress) {
    return false;
  }

  // TODO Refactor once boolean loading flag is exposed from ShoppingCart, rather than replying on cartProductInProgress object
  return Boolean(Object.keys(cartProductInProgress).length);
};
